import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../actions";

const SEARCH_TIMEOUT = 200;
const MIN_CHARACTER_LENGTH = 3;

class MerchantSearchContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { searcher: null };
  }

  componentDidMount() {
    this.refs.searchParam.focus();
  }

  searchMerchant() {
    const merchantHost = this.props.endpoints.apiHost;
    const searchParam = this.refs.searchParam.value;
    const limit = 20;
    const offset = 0;
    this.props.dispatch(actions.getMerchants(merchantHost, offset, limit, searchParam));
  }

  disableSubmit(e) {
    e.preventDefault();
  }

  searchChanged() {
    this.props.dispatch(actions.setSearchParam(this.refs.searchParam.value));
    // remove any exsiting untriggered search timeout
    if (this.state.searcher) {
      window.clearTimeout(this.state.searcher);
    }
    if (this.refs.searchParam.value.length >= MIN_CHARACTER_LENGTH) {
      this.state.searcher = window.setTimeout(() => {
        this.searchMerchant();
      }, SEARCH_TIMEOUT);
    }
  }

  render() {
    return (
      <form onSubmit={this.disableSubmit}>
        <div className="serach-container" style={{ marginTop: 40, marginBottom: 20, width: "100%" }}>
          <label htmlFor="searchparam"></label>
          <input
            style={{ width: "100%" }}
            className="new-input"
            ref="searchParam"
            type="text"
            name=""
            placeholder="Type to search for a merchant"
            onChange={() => this.searchChanged()}
            value={this.props.impersonation.get("searchParam")}
          />
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    impersonation: state.get("impersonation"),
  };
};

export default connect(mapStateToProps)(MerchantSearchContainer);
